import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class TokenService extends CommonService {
    constructor(http) {
        super(http);
    }



    nvToken(idEmpr) {
        let url = `integracoes/token/novo/${idEmpr}`;
        const body = JSON.stringify({ nvToken: true });
        return this._resource.post(url, body).then(success => {
            return success;
        },
            failed => {
                return failed;
            })
    }
    vinculaEmpr(idEmpr, refEmpresa) {
        let url = `integracoes/token/novo/${idEmpr}`;
        const body = JSON.stringify({ nvToken: false, refEmpresa: refEmpresa });
        return this._resource.post(url, body).then(success => {
            return success;
        },
            failed => {
                return failed;
            })
    }
    buscaToken(idEmpr){
        let url = `integracoes/token/${idEmpr}`;
        return this._resource.get(url).then(
            success =>{
                return success;
            },
            failed =>{
                return failed;
            }
        )
    }

}


// WEBPACK FOOTER //
// ./src/domain/conta/empresa/token/TokenService.js